module.exports = __webpack_public_path__ + "static/media/ballon.5cf97aeb.png";